module.exports = __webpack_public_path__ + "img/symbol_10.05d27c93.png";